// Hardcoded on BE as well
export const EUROPE_REGION_ID = '647d8ca9-6dd3-4423-a8f5-c5226e38a4bb';
export const NA_REGION_ID = 'cd1de1df-111c-4278-a7c6-a6dbfa5e49b9';
const SERVICE_REGION_IDS = [EUROPE_REGION_ID, NA_REGION_ID] as const;

export type ServiceRegionId = (typeof SERVICE_REGION_IDS)[number];

export const regionDefaultTimezoneById: Record<ServiceRegionId, string> = {
  [EUROPE_REGION_ID]: 'Europe/Rome',
  [NA_REGION_ID]: 'America/New_York',
};

export const regionDefaultCountryById: Record<ServiceRegionId, string> = {
  [EUROPE_REGION_ID]: 'IT',
  [NA_REGION_ID]: 'US',
};

export const serviceRegionNameById: Record<ServiceRegionId, string> = {
  [EUROPE_REGION_ID]: 'Europe',
  [NA_REGION_ID]: 'North America',
};
